import { gql, useMutation } from '@apollo/client';
import {
  Button,
  ButtonGroup,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalTitle,
} from '@apollo/orbit';
import React from 'react';

import { ErrorMessage } from 'src/components/errorMessage/ErrorMessage';
import { GraphQLTypes } from 'src/lib/graphqlTypes';

import { GraphRef } from '../../hooks/useGraphRef';

export const DeleteHomepageLinkModal = ({
  isOpen,
  onClose,
  link,
  graphRef,
}: {
  isOpen: boolean;
  onClose: () => void;
  link: GraphQLTypes.LinksContentGraphVariantFragment_links;
  graphRef: GraphRef;
}) => {
  const [deleteLink, { loading, error }] = useMutation<
    GraphQLTypes.RemoveLinkFromVariantMutation,
    GraphQLTypes.RemoveLinkFromVariantMutationVariables
  >(
    gql`
      mutation RemoveLinkFromVariantMutation(
        $linkId: ID!
        $graphVariant: String!
        $graphId: ID!
      ) {
        service(id: $graphId) {
          variant(name: $graphVariant) {
            id
            removeLinkFromVariant(linkInfoId: $linkId) {
              id
              links {
                type
                url
                title
                id
              }
            }
          }
        }
      }
    `,
    {
      onCompleted: () => onClose(),
    },
  );

  const onSubmitForDeletion = async () => {
    await deleteLink({
      variables: {
        linkId: link.id,
        graphId: graphRef.graphId,
        graphVariant: graphRef.graphVariant,
      },
    });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <ModalTitle>Delete this link?</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <div>
            <span>Please confirm you’d like to delete the link: </span>
            <span className="font-semibold">
              {link.type === GraphQLTypes.LinkInfoType.OTHER
                ? link.title
                : link.type === GraphQLTypes.LinkInfoType.DEVELOPER_PORTAL
                  ? 'Developer portal'
                  : link.url}
            </span>
          </div>
          {error && <ErrorMessage error={error} />}
        </ModalBody>
        <ModalFooter>
          <ButtonGroup>
            <Button
              variant="secondary"
              isDisabled={loading}
              onClick={onClose}
              type="button"
            >
              Cancel
            </Button>
            <Button
              variant="destructive"
              isLoading={loading}
              loadingText="🔥 Yes, delete it"
              onClick={onSubmitForDeletion}
              type="button"
            >
              🔥 Yes, delete it
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
